import { render, staticRenderFns } from "./CotizacionIndividualComparador.vue?vue&type=template&id=04656418&scoped=true&"
import script from "./CotizacionIndividualComparador.vue?vue&type=script&lang=js&"
export * from "./CotizacionIndividualComparador.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionIndividualComparador.vue?vue&type=style&index=0&id=04656418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04656418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VImg,VProgressCircular,VRow})
